import AliquotaService from "@/services/AliquotaService";

export const aliquota = {
  namespaced: true,
  state: {
    aliquota: {},
  },
  actions: {
    getAliquota({ commit }, payload) {
      return AliquotaService.GetAliquota(payload).then(
        (aliquota) => {
          return Promise.resolve(aliquota);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAliquota({ commit }, payload) {
      return AliquotaService.PostAliquota(payload).then(
        (aliquota) => {
          return Promise.resolve(aliquota);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAliquota({ commit }, payload) {
      return AliquotaService.PutAliquota(payload).then(
        (aliquota) => {
          return Promise.resolve(aliquota);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAliquota({ commit }, payload) {
      return AliquotaService.DeleteAliquota(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAliquotaOData({ commit }, payload) {
      return AliquotaService.GetAliquotaOData(payload).then(
        (aliquota) => {
          return Promise.resolve(aliquota);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default aliquota;
